import React, { useState, Component } from 'react';
import { useLanguage } from './LanguageContext';
import { CheckCircle2, Lock, Phone, Mail, MapPin } from 'lucide-react';
export const ContactForm = () => {
  const {
    t
  } = useLanguage();
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [service, setService] = useState('');
  const [date, setDate] = useState('');
  const trustItems = [t('contact.t1'), t('contact.t2'), t('contact.t3'), t('contact.t4')];
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const message = `Hi! I'd like a Free Estimate 🧹
👤 Name: ${name}
📞 Phone: ${phone}
🧺 Service: ${service}
📅 Date: ${date}

Please contact me!`;
    const encoded = encodeURIComponent(message);
    const whatsappNumber = '17866603720';
    window.open(`https://wa.me/${whatsappNumber}?text=${encoded}`, '_blank');
  };
  return <section id="contact" className="bg-brand-marble py-20" data-id="element-37">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-38">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-39">
          {/* Left Side */}
          <div data-id="element-40">
            <h2 className="font-montserrat font-extrabold text-[32px] md:text-[42px] text-brand-navy leading-tight mb-8" data-id="element-41">
              {t('contact.title1')}
              <br data-id="element-42" />
              <span className="text-brand-gold" data-id="element-43">{t('contact.title2')}</span>
            </h2>

            <div className="space-y-4 mb-10" data-id="element-44">
              {trustItems.map((item, index) => <div key={index} className="flex items-center gap-3" data-id="element-45">
                  <CheckCircle2 className="text-brand-gold" size={24} data-id="element-46" />
                  <span className="font-inter font-medium text-lg text-brand-navy" data-id="element-47">
                    {item}
                  </span>
                </div>)}
            </div>

            {/* Direct Contact Info */}
            <div className="border-t border-brand-gold/30 pt-8" data-id="element-48">
              <h3 className="font-montserrat font-bold text-brand-navy text-sm tracking-[3px] uppercase mb-5" data-id="element-49">
                {t('contact.info')}
              </h3>
              <ul className="space-y-3" data-id="element-50">
                <li className="flex items-center gap-3 text-brand-navy" data-id="element-51">
                  <Phone size={18} className="text-brand-gold" data-id="element-52" />
                  <a href="tel:7866603720" className="font-inter font-medium hover:text-brand-gold transition-colors" data-id="element-53">
                    (786) 660-3720
                  </a>
                </li>
                <li className="flex items-center gap-3 text-brand-navy" data-id="element-54">
                  <Phone size={18} className="text-brand-gold" data-id="element-55" />
                  <a href="tel:7865602192" className="font-inter font-medium hover:text-brand-gold transition-colors" data-id="element-56">
                    (786) 560-2192
                  </a>
                  <span className="text-xs text-gray-500 italic" data-id="element-57">
                    {t('footer.backup')}
                  </span>
                </li>
                <li className="flex items-center gap-3 text-brand-navy" data-id="element-58">
                  <Mail size={18} className="text-brand-gold" data-id="element-59" />
                  <a href="mailto:twomopgirlsco@gmail.com" className="font-inter font-medium hover:text-brand-gold transition-colors break-all" data-id="element-60">
                    twomopgirlsco@gmail.com
                  </a>
                </li>
                <li className="flex items-center gap-3 text-brand-navy" data-id="element-61">
                  <MapPin size={18} className="text-brand-gold" data-id="element-62" />
                  <span className="font-inter font-medium" data-id="element-63">
                    Miami and Broward Area
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Right Side - Form */}
          <div className="bg-white rounded-[20px] shadow-[0_12px_40px_rgba(27,43,94,0.10)] border border-brand-gold/25 p-8 md:p-10" data-id="element-64">
            <form className="space-y-5" onSubmit={handleSubmit} data-id="element-65">
              <div data-id="element-66">
                <input id="name" type="text" value={name} onChange={e => setName(e.target.value)} placeholder={t('contact.f.name')} className="w-full h-[52px] px-4 border-[1.5px] border-brand-gold/30 rounded-[10px] font-inter focus:outline-none focus:border-brand-gold focus:ring-[3px] focus:ring-brand-gold/15 transition-all" required data-id="element-67" />
              </div>

              <div data-id="element-68">
                <input id="phone" type="tel" value={phone} onChange={e => setPhone(e.target.value)} placeholder={t('contact.f.phone')} className="w-full h-[52px] px-4 border-[1.5px] border-brand-gold/30 rounded-[10px] font-inter focus:outline-none focus:border-brand-gold focus:ring-[3px] focus:ring-brand-gold/15 transition-all" required data-id="element-69" />
              </div>

              <div data-id="element-70">
                <select id="service" value={service} onChange={e => setService(e.target.value)} className="w-full h-[52px] px-4 border-[1.5px] border-brand-gold/30 rounded-[10px] font-inter text-gray-600 focus:outline-none focus:border-brand-gold focus:ring-[3px] focus:ring-brand-gold/15 transition-all bg-white" required data-id="element-71">
                  <option value="" disabled data-id="element-72">
                    {t('contact.f.service')}
                  </option>
                  <option value={t('contact.f.s1')} data-id="element-73">{t('contact.f.s1')}</option>
                  <option value={t('contact.f.s2')} data-id="element-74">{t('contact.f.s2')}</option>
                  <option value={t('contact.f.s3')} data-id="element-75">{t('contact.f.s3')}</option>
                  <option value={t('contact.f.s4')} data-id="element-76">{t('contact.f.s4')}</option>
                  <option value={t('contact.f.s5')} data-id="element-77">{t('contact.f.s5')}</option>
                  <option value={t('contact.f.s6')} data-id="element-78">{t('contact.f.s6')}</option>
                </select>
              </div>

              <div data-id="element-79">
                <input id="date" type="datetime-local" value={date} onChange={e => setDate(e.target.value)} className="w-full h-[52px] px-4 border-[1.5px] border-brand-gold/30 rounded-[10px] font-inter text-gray-600 focus:outline-none focus:border-brand-gold focus:ring-[3px] focus:ring-brand-gold/15 transition-all" required data-id="element-80" />
              </div>

              <button type="submit" className="w-full h-[56px] bg-brand-navy hover:bg-brand-gold hover:text-brand-navy hover:scale-[1.02] transition-all duration-300 text-white font-montserrat font-bold rounded-[12px] mt-2" data-id="element-81">
                {t('contact.submit')}
              </button>

              <div className="flex items-center justify-center gap-2 mt-4 text-gray-500 text-sm" data-id="element-82">
                <Lock size={14} data-id="element-83" />
                <span data-id="element-84">{t('contact.privacy')}</span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>;
};